import type { UIMessage } from "@ai-sdk/react"
import { isToolUIPart } from "ai"
import type { DynamicToolUIPart, ToolUIPart, UITools } from "ai"
import { useEffect, useRef } from "react"

import { executeAssistantClientToolPartIfNeeded } from "~components/outfitter-assistant/assistant-client-tool-handlers"

type AnyToolUIPart = ToolUIPart<UITools> | DynamicToolUIPart

/**
 * Walks assistant messages for completed tool calls and executes matching
 * client-side handlers (navigation, email template editor, etc.) exactly once
 * per `toolCallId`.
 */
export default function useExecuteAssistantToolCalls(
    messages: readonly UIMessage[]
): void {
    const executedToolCallIdsRef = useRef<Set<string>>(new Set())

    useEffect(() => {
        const parts = collectToolParts(messages)
        parts.forEach((part) =>
            executeAssistantClientToolPartIfNeeded({
                part,
                executedToolCallIds: executedToolCallIdsRef.current,
            })
        )
    }, [messages])
}

function collectToolParts(
    messages: readonly UIMessage[]
): readonly AnyToolUIPart[] {
    return messages.flatMap((message) => message.parts.filter(isToolUIPart))
}
